/*
 * Everything related to acquisition and management of local media devices (camera and mic)
 * on the user's system.
 */

import { createLocalVideoTrack, createLocalAudioTrack, createLocalTracks } from 'twilio-video';

class DeviceManager {
  constructor() {
    this.audio = null
    this.video = null
  }

  init() {
    this.audio = this.acquire("audio")
    this.video = this.acquire("video")
    return Promise.all([this.audio, this.video])
  }

  acquire(mediaType) {
    let audio, video = false

    if (mediaType === "audio") [audio, video] = [true, false]
    else if (mediaType === "video") [audio, video] = [false, true]
    else throw Error("No media device type specified")

    return navigator.mediaDevices.getUserMedia({
      audio: audio,
      video: video ? { width: 1280, height:720, aspectRatio:1280/720 } : false
    }).then(() => {
      return {[mediaType]: true}
    }).catch(() => {
      console.log(`Cannot access ${mediaType} source.`)
      return {[mediaType]: false}
    })
  }
}

export default DeviceManager